import { AxiosRequestConfig } from 'axios'

import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'
import { DefaultPhysiologicalRegisterForm } from '@/pages/demands/steps/physiological-register/hooks/use-physiological-register-form'
import { Culture } from '@/types/culture'
import { Treatment } from '@/types/treatment'

interface Field {
  id: string
  name: string
  intersection_percentage: number
}

export interface CreateDiagnosisPayload {
  demand_name: string
  company: {
    id: number
    name: string
  }
  user: {
    id: number
    name: string
    email: string
  }
  project: { id: number; name: string; region_id?: number }
  flight_date: string
  input_image_type: 'mosaic' | 'raw_images' | 'raw_images_geotag'
  perimeter: {
    area: number
    lat_long: [number, number]
  }
  mosaic?: {
    image_name: string
    image_gsd: number
    coord_x: number
    coord_y: number
    px_res: number
  }
  flight_info?: DefaultPhysiologicalRegisterForm
  image_count?: number
  mapping_id: string | null
  fields?: Field[]
  culture: Culture
  treatment: Treatment
  planting_type?: 'convencional' | 'duplo_alternado' | 'meiosi'
  planting_space?: number
  cane_cycle_type?: 'nao_especificado' | 'cana_planta' | 'cana_soca'
}

export interface CreateDiagnosisResponse {
  demand_id: string
  mosaic_id?: string
}

export async function createDiagnosis(
  treatment: Treatment,
  culture: Culture,
  newDemand: CreateDiagnosisPayload,
  config?: AxiosRequestConfig,
) {
  const { data } = await companiesApi.post<CreateDiagnosisResponse>(
    apiRoutes.createDiagnosis(treatment, culture),
    newDemand,
    config,
  )

  return data
}
